import type { Locale } from '@fastnorth/i18next';
import { AVAILABLE_LOCALES } from '@fastnorth/i18next';
import i18n from 'i18next';
import { DEFAULT_LOCAL_STORAGE_USER_LOCALE_KEY } from '../../config/constants';
import storage from '../../lib/storage/localStore';

const setUserLocale = async (locale: Locale): Promise<void> => {
  if (AVAILABLE_LOCALES[locale] != null) {
    await storage.setItem(DEFAULT_LOCAL_STORAGE_USER_LOCALE_KEY, locale);
    // eslint-disable-next-line import/no-named-as-default-member
    await i18n.changeLanguage(locale);
  }
};

export default setUserLocale;
